<template>
  <drawer
    v-if="simulation"
    :title="$t('labels.simulationInfo')"
    :open="open"
    v-bind="$attrs"
  >
    <div class="label">
      {{ $t("objectNames.scenario") }}
    </div>
    <button-item v-if="scenario">
      {{ scenario.title }}
      <template #icons>
        <button
          type="button"
          class="button-icon button-item__icon"
          @click="openOverlay(scenario)"
        >
          <lucide-icon name="info" />
        </button>
      </template>
    </button-item>
    <p v-else class="message mt-1">
      {{ $t("messages.simulationHasNoScenario") }}
    </p>

    <div class="label mt-4">
      {{ $t("labels.description") }}
    </div>
    <formatted-text :value="simulation.description" />

    <div>{{ $t("labels.playedXRounds", [playedRoundAmount]) }}</div>
    <button type="button" class="button mt-2" @click="openOverlay(simulation)">
      {{ $t("labels.moreInfo") }}
    </button>
  </drawer>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Drawer from "@core/ui/DrawerBlock.vue";
import ButtonItem from "@core/input/ButtonItem.vue";
import FormattedText from "@core/ui/FormattedText.vue";
import LucideIcon from "@core/ui/LucideIcon.vue";

import { useSimulationViewStore } from "@editor/views/simulation/simulationView.store";
import { useOverlay } from "@editor/ui/overlayDialog.store";

import type { OverlayDialogItemRequest } from "@editor/ui/OverlayDialogItem";

withDefaults(defineProps<{
  open: boolean;
}>(), {
  open: false
});


const simulation = computed(() => {
  return useSimulationViewStore().simulation;
});
const scenario = computed(() => {
  return useSimulationViewStore().scenario;
});
const playedRoundAmount = computed(() => {
  if (!simulation.value) return 0;
  const index = simulation.value.currentRoundIndex;
  if (simulation.value.complete) return index + 1;
  return index;
});

function openOverlay(item: OverlayDialogItemRequest) {
  useOverlay().setItem(item);
}
</script>

<style lang="scss"></style>
